/* =====================================================================
   BUDDLEY - "Categorieën" mega-menu besturing (v6)
   Alleen zichtbaar/actief op desktop (>= 990px); mobiel gebruikt het
   standaard hamburgermenu (snippets/mobile-menu.liquid).
   Opent op klik en op hover. Groepen links schakelen het paneel rechts
   (subitems + productvoorbeelden) om. Sluit bij klik buiten, Escape, of
   het verlaten van het menu.
   v6: de productvoorbeelden worden los opgehaald via
   ?section_id=buddley-cat-products, bij het eerste openen of zodra de
   browser na het laden van de pagina tijd over heeft.
   ===================================================================== */
(function () {
  function init() {
    var root = document.querySelector('[data-bud-cat]');
    if (!root) return;

    var trigger = root.querySelector('.bud-cat__trigger');
    var panel = root.querySelector('.bud-cat__panel');
    if (!trigger || !panel) return;

    var groupTriggers = root.querySelectorAll('[data-group-trigger]');
    var groupItems = root.querySelectorAll('.bud-cat__group-item');
    var subpanels = root.querySelectorAll('[data-subpanel]');
    var productTriggers = root.querySelectorAll('[data-products-trigger]');

    var mq = window.matchMedia('(min-width: 990px)');
    var closeTimer = null;
    var activeGroup = '0';

    // Productvoorbeelden los ophalen (een keer per pagina)
    var productsState = 'idle';
    function loadProducts() {
      if (productsState !== 'idle') return;
      productsState = 'loading';
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + '?section_id=buddley-cat-products', { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) { throw new Error(res.status); } return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('[data-products-slot]').forEach(function (src) {
            var target = root.querySelector('.bud-cat__products-wrap[data-products-slot="' + src.getAttribute('data-products-slot') + '"]');
            if (target) { target.innerHTML = src.innerHTML; }
          });
          productsState = 'done';
          setupScrollReveal();
          showGroup(activeGroup);
        })
        .catch(function () { productsState = 'idle'; });
    }

    function open() {
      clearTimeout(closeTimer);
      loadProducts();
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
    }
    function close() {
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
    }
    function toggle() {
      if (root.classList.contains('is-open')) { close(); } else { open(); }
    }
    function showGroup(index) {
      activeGroup = String(index);
      groupItems.forEach(function (el) {
        el.classList.toggle('is-active', el.dataset.group === String(index));
      });
      subpanels.forEach(function (el) {
        el.classList.toggle('is-active', el.dataset.subpanel === String(index));
      });
      // Bij het wisselen van groep: altijd terug naar de standaard productenset van de groep
      showProducts('group-' + index, root.querySelector('[data-subpanel="' + index + '"]'));
    }
    function showProducts(key, scopeEl) {
      var scope = scopeEl || root.querySelector('.bud-cat__subpanel.is-active');
      if (!scope) return;
      var sets = scope.querySelectorAll('[data-products-key]');
      sets.forEach(function (el) {
        var isMatch = el.getAttribute('data-products-key') === key;
        el.classList.toggle('is-active', isMatch);
        if (isMatch) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
      });
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggle();
    });
    trigger.addEventListener('focus', loadProducts);

    // Groep hoveren/focussen -> paneel rechts wisselen (incl. reset naar groep-producten)
    groupTriggers.forEach(function (el) {
      var index = el.getAttribute('data-group-trigger');
      el.addEventListener('mouseenter', function () { if (mq.matches) { showGroup(index); } });
      el.addEventListener('focus', function () { showGroup(index); });
    });

    // Subcategorie hoveren/focussen -> productenset van DIE subcategorie tonen
    productTriggers.forEach(function (el) {
      var key = el.getAttribute('data-products-trigger');
      var scope = el.closest('.bud-cat__subpanel');
      el.addEventListener('mouseenter', function () { if (mq.matches) { showProducts(key, scope); } });
      el.addEventListener('focus', function () { showProducts(key, scope); });
    });

    // Muis weg van de subcategorie-lijst -> terug naar de standaard groep-producten
    root.querySelectorAll('.bud-cat__sublist').forEach(function (list) {
      list.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        var scope = list.closest('.bud-cat__subpanel');
        var groupIndex = scope ? scope.getAttribute('data-subpanel') : null;
        if (groupIndex !== null) { showProducts('group-' + groupIndex, scope); }
      });
    });

    // Scroll-paginering: bij groepen zonder subitems worden de producten in
    // batches vloeiend getoond. Werkt via IntersectionObserver op een
    // 'sentinel'-element aan het einde van de lijst. Wordt ingesteld zodra
    // de productvoorbeelden binnen zijn.
    var BATCH_SIZE = 8;
    var subpanelsEl = root.querySelector('.bud-cat__subpanels');
    function revealNextBatch(listEl) {
      var pending = listEl.querySelectorAll('.bud-cat__product-item.is-pending');
      for (var i = 0; i < pending.length && i < BATCH_SIZE; i++) {
        pending[i].classList.remove('is-pending');
        pending[i].classList.add('is-revealing');
      }
      return pending.length > BATCH_SIZE;
    }
    function setupScrollReveal() {
      if (!window.IntersectionObserver) return;
      var sentinels = root.querySelectorAll('.bud-cat__scroll-sentinel');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var listEl = entry.target.closest('.bud-cat__products--scroll');
          if (listEl) { revealNextBatch(listEl); }
        });
      }, { root: subpanelsEl || null, rootMargin: '200px', threshold: 0 });
      sentinels.forEach(function (el) { observer.observe(el); });
    }

    // Hover-gedrag op desktop voor het hele menu
    root.addEventListener('mouseenter', function () {
      if (mq.matches) { open(); }
    });
    root.addEventListener('mouseleave', function () {
      if (mq.matches) { closeTimer = setTimeout(close, 180); }
    });

    // Sluiten bij klik buiten het menu
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) { close(); }
    });

    // Sluiten met Escape, focus terug naar de trigger-knop
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); trigger.focus(); }
    });

    // Op desktop alvast ophalen zodra de pagina geladen is en de browser tijd over heeft
    function preload() {
      if (!mq.matches) return;
      if (window.requestIdleCallback) { window.requestIdleCallback(loadProducts, { timeout: 4000 }); }
      else { setTimeout(loadProducts, 2000); }
    }
    if (document.readyState === 'complete') { preload(); }
    else { window.addEventListener('load', preload); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* === CART COUNT BADGE: verberg bij 0 ================================= */
(function () {
  function updateCartBadge() {
    var badges = document.querySelectorAll('.header__cart-count');
    badges.forEach(function (badge) {
      var count = parseInt(badge.textContent.trim(), 10);
      badge.style.display = (isNaN(count) || count === 0) ? 'none' : '';
    });
  }
  document.addEventListener('DOMContentLoaded', updateCartBadge);
  document.addEventListener('cart:refresh', updateCartBadge);
  document.addEventListener('cart:updated', updateCartBadge);
  if (document.readyState !== 'loading') updateCartBadge();
})();

/* === Fix: verwijder target="_blank" van tel: links ================== */
(function () {
  function fixTelLinks() {
    document.querySelectorAll('a[href^="tel:"]').forEach(function (a) {
      a.removeAttribute('target');
      a.removeAttribute('rel');
      a.removeAttribute('aria-describedby');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixTelLinks);
  } else {
    fixTelLinks();
  }
})();
